import { Component, EventEmitter, Output } from '@angular/core';
import { DynamicContainerBaseComponent } from '@ups/xplat/dynamic-render';

@Component({
  selector: 'ups-dynamic-admin-container',
  styleUrls: ['dynamic-admin-container.component.scss'],
  templateUrl: 'dynamic-admin-container.component.html',
  standalone: false,
})
export class DynamicAdminContainerComponent extends DynamicContainerBaseComponent {
  @Output()
  formBuilderItemSelected: EventEmitter<unknown> = new EventEmitter();
  @Output()
  formBuilderItemReordered: EventEmitter<unknown> = new EventEmitter();

  drop(args: unknown) {
    this.formBuilderItemReordered.emit(args);
  }
}
